module.exports = __webpack_public_path__ + "media/nb_no_s1_Annemari.e811237c.mp3";